import { Globe2 } from "lucide-react";
import { Select } from "./ui/select";

interface LanguagePickerProps { readonly value: string; readonly options: readonly { readonly code: string; readonly label: string }[]; readonly onChange: (value: string) => void; readonly compact?: boolean; }

export function LanguagePicker({ value, options, onChange, compact = false }: LanguagePickerProps): React.JSX.Element {
  const items = options.map((option) => ({ value: option.code, label: option.label }));
  return <div className="flex min-w-0 items-center gap-1.5"><Globe2 aria-hidden="true" className="hidden size-4 shrink-0 text-slate-500 sm:block" /><Select value={value} items={items} ariaLabel="Language" onValueChange={onChange} className={compact ? "w-[92px] sm:w-[118px]" : "w-[152px]"} /></div>;
}
